import * as stylex from '@stylexjs/stylex';
import { appLink } from '~components/AppCta';
import { shared } from '~styles';
import { styles } from './styles';
export function Stub({
  id
}: {
  id: string;
}) {
  return <main {...stylex.props(styles.container)}>
      <h1>Profile unavailable</h1>
      <p {...stylex.props(shared.muted)}>This profile is no longer available.</p>
      <a {...stylex.props(shared.primaryButton, styles.button)} href={appLink(`profile/${id}`)}>
        Open in the Tribys app
      </a>
    </main>;
}